import { useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { useForm } from '@kanda-libs/ks-component-ts';
import { StringIndexedObject, useToast } from '@kanda-libs/ks-design-library';
import { Signature } from '@kanda-libs/ks-frontend-services';

import { DocumentPage, useOmniSignDocumentsContext } from '../context';

interface FingerprintBoolean {
  value: boolean;
  timestamp: number;
  ip: string;
}

export interface OmniSignDocumentsFormFields {
  preContact: FingerprintBoolean;
  directDebit: FingerprintBoolean;
  creditAgreement: FingerprintBoolean;
}

interface OmniSignDocumentsFormHook {
  page: DocumentPage;
  form: UseFormReturn<OmniSignDocumentsFormFields>;
  onSubmit: (data: StringIndexedObject<OmniSignDocumentsFormFields>) => void;
  onClick: () => void;
  isSubmitting: boolean;
}

export default function useOmniSignDocumentsForm(
  handleClose?: () => void,
): OmniSignDocumentsFormHook {
  const { showError } = useToast();

  const { page, isSubmitting, signDocuments } = useOmniSignDocumentsContext();

  const form = useForm<OmniSignDocumentsFormFields>({
    mode: 'onBlur',
  });

  const onSubmit = useCallback(
    (formValues: StringIndexedObject) => {
      const allSigned =
        formValues?.preContact?.value &&
        formValues?.directDebit?.value &&
        formValues?.creditAgreement?.value;
      const ip =
        formValues?.preContact?.ip ||
        formValues?.directDebit?.ip ||
        formValues?.creditAgreement?.ip;
      if (!allSigned) {
        showError(
          'Not all documents are signed - please go back through them and ensure all douments are signed',
        );
        return;
      }
      const body: Signature = {
        signed: 'yes',
        fingerprint: ip,
      };
      signDocuments(body);
    },
    [showError, signDocuments],
  );

  const onClick = useCallback(() => {
    if (handleClose) handleClose();
  }, [handleClose]);

  return {
    page,
    form,
    onClick,
    onSubmit,
    isSubmitting,
  };
}
